module.exports = __webpack_public_path__ + "img/1500800966.26221095.jpg";